import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { MDBCardTitle, MDBCardText, MDBBtn, MDBTable, MDBTableHead, MDBTableBody, MDBCard, MDBCardBody } from 'mdb-react-ui-kit';
import '../../../css/index.css';



function ListarRelacionamentoResponsavel() {

  const api = require('../../../apis/relacionamento-responsavel')
  const [usuarios, setUsuarios] = useState([]);
  const utils = require('../../../utils/index');
  const user = utils.getUser();

  const obj = utils.decideBody(user)

  const navigate = useNavigate();

  const getUsers = async () => {
    try {
      
      if ( user.tipouser != 5){
        obj.idEscola = user.idescola;
      }

      if ( user.tipouser == 4){
        obj.idEscola = user.idescola,
        obj.idFilial = user.idfilial
      }
  
      // Simulando uma chamada assíncrona (substitua por sua lógica real)
      const response = await api.listarResponsavelApi(obj);
      const data = await response;

      // Verificando se os dados são uma array antes de definir o estado
      if (Array.isArray(data)) {
        setUsuarios(data);
      } else {
        console.error('Os dados obtidos não são uma array:', data);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  // Chame a função de busca quando o componente for montado
  useEffect(() => {
    getUsers( );
  }, []); 
  return (
    <div className="w-100 d-flex align-items-center justify-content-center" style={{height:'100vh'}}>
      <MDBCard className='bg-dark w-75' style={{minWidth:'350px'}}>
        <MDBCardBody className='bg-dark w-100 text-white'>
        <MDBCardTitle className='text-white'>Bem vindo, {utils.decideName(user)}</MDBCardTitle>
          <MDBCardText className='text-white'>
            O que veio fazer?
          </MDBCardText>
          <div style={{maxHeight: '500px', overflow: 'auto'}}>
            <MDBTable align='middle' className='text-white '  >
              <MDBTableHead>
                <tr>
                  <th scope='col'>Nome Responsavel</th>
                  <th scope='col'>CPF</th>
                  <th scope='col'>Nome Aluno</th>
                  <th scope='col'>RA</th>
                  <th scope='col'>Identificador escola</th>
                  <th scope='col'>Identificador filial</th>
                  <th scope='col'>Ações</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody >
              {usuarios.map((usuario) => (
                  <tr key={usuario.id}>
                  <td>{usuario.nome_responsavel}</td>
                  <td>{usuario.idresponsavel}</td>
                  <td>{usuario.nome_aluno}</td>
                  <td>{usuario.aluno}</td>
                  <td>{usuario.idescola}</td>
                  <td>{usuario.idfilial}</td>
                  <td>
                    <MDBBtn 
                      color='link' 
                      rounded 
                      size='sm'
                      disabled={user.tipouser != 3}
                      onClick={() => {
                        navigate(`/editar-relacionamento-responsavel/${usuario.idresponsavel}/${usuario.aluno}`)
                      }}
                      >
                      Editar
                    </MDBBtn>
                  </td>
                </tr>
              ))}
              </MDBTableBody>
            </MDBTable>
          </div>
          <MDBBtn 
              className='btn-home w-100 mt-4'
              size='sm'
              outline 
              color='white' 
              onClick={() => {
                navigate("/area-relacionamento-responsavel")
              }}
              >Voltar</MDBBtn>
        </MDBCardBody>
      </MDBCard>
    </div>
  );
}

export default ListarRelacionamentoResponsavel;
